import {keys} from "../config/nameSpacesKeys";
import GenericLangValue from "./GenericLangValue";
import {assetKeys} from "../config/constants";
import TypeValue from "./TypeValue";

export default class AdmsIdentifier {
  constructor(name, initialValue, namespace, notationNameSpace, schemaAgencyNameSpace) {
    this.namespace = namespace;
    this.name = name;
    this.notationNameSpace = notationNameSpace;
    this.schemaAgencyNameSpace = schemaAgencyNameSpace;
    this.schemaAgency = new GenericLangValue(name = "schemaAgency", null, keys.schemaAgency);
    this.notation = new TypeValue("notation", null, notationNameSpace, keys.stringType);
    if (initialValue) {
      this.parseInputJSON(initialValue);
    }
  }

  getNameSpace() {
    return this.namespace;
  }

  getSchemaAgencyObj() {
    return this.schemaAgency;
  }

  setSchemaAgency(schemaAgencyObj) {
    this.schemaAgency = schemaAgencyObj;
  }

  getNotationObj() {
    return this.notation;
  }

  setNotation(notationObj) {
    this.notation = notationObj;
  }

  parseInputJSON(inputJSON) {
    // console.log(inputJSON);
    const obj = inputJSON;// [this.namespace];
    if (Array.isArray(obj)) {
      for (const entry of Object.entries(obj)) {
        const value = entry[1];
        this.setValueObj(value);
      }
    } else {
      this.setValueObj(obj);
    }
  }

  setValueObj(obj) {
    // console.log(obj);
    this.schemaAgency.parseInputJSON(obj);
    this.notation.parseInputJSON(obj);
  }

  getExpandedFormatValue() {
    const obj = {};
    obj[assetKeys.type] = [`${keys.admsIdentifierCapital}`];
    const schemaAgencyExpanded = this.schemaAgency.getExpandedFormatValue();
    obj[this.schemaAgency.getNameSpace()] = schemaAgencyExpanded;
    obj[this.notationNameSpace] = this.notation.getExpandedFormatValue();
    // console.log("test", obj);
    return obj;
  }

  isEmpty() {
    return this.notation.isEmpty() && this.schemaAgency.isEmpty(); // && this.admsId.isEmpty();
  }
}
